import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MonitorIcon(props: IconProps) {
    return <Icon {...props} iconKey={"monitor"}/>
}
